var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "custom-select" },
    [
      _c("el-input", {
        style: { width: "100%" },
        attrs: {
          placeholder: "请输入搜索内容",
          clearable: "",
          loading: _vm.loading,
        },
        on: { input: _vm.handleInput, focus: _vm.handleFocus },
        model: {
          value: _vm.keyword,
          callback: function ($$v) {
            _vm.keyword = $$v
          },
          expression: "keyword",
        },
      }),
      _vm.showDropdown && _vm.formattedOptions.length > 0
        ? _c(
            "el-dropdown",
            { attrs: { trigger: "click" } },
            [
              _c(
                "el-dropdown-menu",
                { attrs: { slot: "dropdown" }, slot: "dropdown" },
                _vm._l(_vm.formattedOptions, function (item) {
                  return _c(
                    "el-dropdown-item",
                    {
                      key: item.value,
                      nativeOn: {
                        click: function ($event) {
                          return _vm.selectItem(item)
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(item.label) + " ")]
                  )
                }),
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }